import { render, staticRenderFns } from "./PensionFood.vue?vue&type=template&id=5b6a7460&"
import script from "./PensionFood.vue?vue&type=script&lang=js&"
export * from "./PensionFood.vue?vue&type=script&lang=js&"
import style0 from "./PensionFood.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports